import { useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { HiOutlinePlay } from "react-icons/hi2";

import Badge from "@/components/atoms/Badge";
import Button from "@/components/atoms/Button";
import StepperItem from "@/components/atoms/StepperItem";
import Modal from "@/components/molecules/Modal";
import PredictiveLeadsIntroModal from "@/components/organisms/predictive/PredictiveLeadsIntroModal";

type PredictiveLeadsHeader = {
  showIntroButton?: boolean;
  steps?: number;
  activeStep?: number;
};

const PredictiveLeadsHeader = ({ showIntroButton = false, steps, activeStep = 1 }: PredictiveLeadsHeader) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={"sticky top-0 z-50 flex items-center justify-between gap-12 bg-white pb-3 pt-4"}>
      <h1
        className={clsx(
          "inline-flex shrink-0 items-center gap-2 text-2xl font-semibold text-primary",
          steps ? "w-1/4" : "w-full",
        )}
      >
        <span>{t("predictive.title")}</span> <Badge label={"BETA"} size={"sm"} color={"secondary"} />
      </h1>

      {steps && (
        <ul className="flex w-full max-w-xl items-center">
          {Array.from({ length: steps }).map((_, index) => (
            <StepperItem
              key={index}
              checked={activeStep > index + 1}
              active={activeStep === index + 1}
              innerContent={index + 1}
            />
          ))}
        </ul>
      )}

      {showIntroButton && (
        <>
          <div className={"flex w-1/4 justify-end"}>
            <Button
              label={t("predictive.intro.watch")}
              onClick={() => setIsOpen(true)}
              color={"natural"}
              trailingIcon={<HiOutlinePlay className={"size-4"} />}
            />
          </div>

          <Modal
            onClose={() => setIsOpen(false)}
            isOpen={isOpen}
            padding={"md"}
            size={"xl"}
            content={PredictiveLeadsIntroModal}
          />
        </>
      )}
    </div>
  );
};

export default PredictiveLeadsHeader;
